<template>
    <div>
        <nfcScanner :app_config="app_config" text="Scan NFC" action="jump_deck_off" :show_tandem_button="true"></nfcScanner>

        <div :class="'jump-deck-status ' + jumpOffStatus">
            <button v-if="discountCustomerFound" class="close" @click="resetJumpOff">&nbsp;</button>
            <span v-if="discountCustomerFound" v-text="statusText"></span>
            <span class="description" v-if="discountCustomerFound" v-text="statusDescription"></span>
        </div>
    </div>
</template>

<script>
import nfcScanner from "./NFCScannerComponent.vue"; 
import { mapState, mapActions } from 'vuex';

export default {
    props: ['app_config'],
    computed: {
        ...mapState([
            'discountCustomerFound',
            'jumpOffStatus',
            'jumpOffDescription',
            'jumpOffReason',
        ]),
        statusText() {
            return (this.jumpOffStatus === 'red') ? 'STOP' : 'GO!';
        },
        statusDescription() {
            return (this.jumpOffStatus === 'red') ? this.jumpOffReason : this.jumpOffDescription;
        }
    },
    methods: {
        ...mapActions(['resetNFCCustomerDetails']),
        resetJumpOff() {
            this.resetNFCCustomerDetails();
        }
    },
    components: {
        nfcScanner
    },
}
</script>
